<template>
  <div class="container" v-loading="loading" element-loading-text="加载中">
    <div class="chart-container" id="chart-container">
      <div @click="printPdf" class="noprint">打印</div>
      <div @click="routeBack" class="noprint">返回</div>
      <div id='printMe'>
        <div class="page page1" v-if="pageOneOpen">
          <div class="title">
            <p>{{ org_name }}</p>
            <p>持续葡萄糖监测（CGM）综合报表</p>
          </div>
          <div class="table-head">
            <table>
              <tr>
                <td width="20%">姓名：{{ patient_info.Name }} </td>
                <td width="25%">性别：{{ patient_info.Sex }}</td>
                <td>年龄：{{ patient_info.Age }}</td>
                <td>手机号：{{ patient_info.Mobile }}</td>
              </tr>
              <tr>
                <td>科室：{{ patient_info.Dept }}</td>
               
                <td>住院号/门诊号：{{ patient_info.AdmitNo }} </td>
                <td>床号:{{patient_info.bed  }}</td>
              </tr>
              <tr>
                <td colspan="2">监测周期：{{ time_range }} </td>
                <td>临床诊断：{{ patient_info.Diag }}</td>
                <td>报告编号：{{ reportNum }}</td>
              </tr>
            </table>
          </div>
          <hr />
          <div class="content" v-if="startRender">
            <table>
              <tr>
                <td width="25%">项目</td>
                <td :key="item" v-for="item in date_list" width="5%">{{ item }}</td>
              </tr>
              <tr :key="row" v-for="row in statistics" class="stat_res">
                <td :key="col" v-for="col in row" v-html="col"></td>
              </tr>
            </table>
          </div>
          <div class="text-wrap" v-if="startRender">
            <p>CGM提示：共测定{{ total_stat['num'][0] }}个血糖值，平均值为{{ total_stat['avg'][0] }}mmol/L，
              标准差为{{ total_stat['sd'][0] }}mmol/L，变异系数为{{ total_stat['cv'][0] }}，
              最高值和最低值分别为{{ total_stat['max'][0] }}mmol/L和{{ total_stat['min'][0] }}mmol/L。</p>
            <p>{{ target_low }}-{{ target_high }}mmol/L (TIR)的时长和百分比为{{ total_stat['bt_3d9_10'][0] }}。</p>
            <p>&ge;7.8mmol/L、&ge;{{ target_high }}mmol/L和&ge;13.9mmol/L的时长和百分比分别为
              {{ total_stat['ge_7d8'][0] }}，{{ total_stat['ge_10'][0] }}，{{ total_stat['ge_13d9'][0] }}。</p>
            <p>&le;{{ target_low }}mmol/L、&le;2.8mmol/L的时长和百分比分别为{{ total_stat['le_3d9'][0] }}，{{ total_stat['le_2d8'][0]
            }}。
            </p>
          </div>
        </div>

        <div class="footer" v-if="pageOneOpen">
          <hr />
          <table>
            <tr>
              <td width="45%">报告者：</td>
              <td>审核者：</td>
              <td class="right">报告日期：</td>
            </tr>
          </table>
        </div>

        <!-- 第二页报告 -->
        <div class="page agp-report" style="page-break-before: always" v-if="pageTwoOpen">
          <div class="title">
            <p>{{ org_name }}</p>
            <p>持续葡萄糖监测（CGM）AGP图表</p>
          </div>
          <div class="table-head">
            <table>
              <tr>
                <td width="20%">姓名：{{ patient_info.Name }} </td>
                <td width="25%">性别：{{ patient_info.Sex }}</td>
                <td>年龄：{{ patient_info.Age }}</td>
                <td>手机号：{{ patient_info.Mobile }}</td>
              </tr>
              <tr>
                <td>科室：{{ patient_info.Dept }}</td>
               
                <td>住院号/门诊号：{{ patient_info.AdmitNo }} </td>
                <td>床号:{{patient_info.bed  }}</td>
              </tr>
              <tr>
                <td colspan="2">监测周期：{{ time_range }} </td>
                <td>临床诊断：{{ patient_info.Diag }}</td>
                <td>报告编号：{{ reportNum }}</td>
              </tr>
            </table>
          </div>

          <hr />

          <div class="content">
            <div class="row1">
              <div class="col1">
                <p>葡萄糖统计</p>
                <table>
                  <tr>
                    <td>CGM使用时间占比<br />{{ AGPStat.cgmUse }}%</td>
                    <td>平均值±标准差<br />MG±SD<br />{{ AGPStat.avgSD }}&nbsp;mmol/L</td>
                    <td>葡萄糖管理指标<br />（GMI）<br />{{ AGPStat.hba1c }}</td>
                    <td>变异系数<br />CV<br />{{ AGPStat.cv }}</td>
                  </tr>
                  <tr>
                    <td>平均波动幅度<br />MAGE<br />{{ AGPStat.avgMage }}</td>
                    <td>平均日间差异<br />(MODD)<br />{{ AGPStat.avgModd }}</td>
                    <td>高血糖事件次数<br />（每天）<br />{{ AGPStat.highSGNum }}</td>
                    <td>低血糖事件次数<br />（每天）<br />{{ AGPStat.lowSGNum }}</td>
                  </tr>
                </table>
              </div>

              <div class="col2">
                <div class="veryhigh" id="dist_very_high">
                </div>
                <div class="high" id="dist_high">
                </div>
                <div class="target" id="dist_target">
                </div>
                <div class="low" id="dist_low">
                </div>
                <div class="veryLow" id="dist_very_low">
                </div>
              </div>

              <div class="col3">
                <div class="target" id="dist_very_high_label">
                  <p>2级高血糖 : &gt;{{ target_veryhigh }} mmol/L ({{ target_over_13d9 }})</p>
                </div>
                <div class="target" id="dist_high_label" style="margin-top:10px">
                  <p>1级高血糖 : {{ (target_high + 0.1).toFixed(1) }}-{{ target_veryhigh }} mmol/L ({{ target_ge_10 }})</p>
                </div>
                <div class="target" id="dist_target_label" style="margin-top:10px">
                  <p>目标范围 : {{ target_low }}-{{ target_high }} mmol/L ({{ target_bt_3d9_10 }})</p>
                </div>
                <div class="target" id="dist_low_label" style="margin-top:10px">
                  <p>1级低血糖 :{{ target_verylow }}-{{ (target_low - 0.1).toFixed(1) }} mmol/L ({{ target_le_3d9 }})</p>
                </div>
                <div class="target" id="dist_very_low_label" style="margin-top:10px">
                  <p>2级低血糖 : &lt;{{ target_verylow }} mmol/L ({{ target_low_3 }})</p>
                </div>
              </div>
            </div>
            <div style="clear: both;"></div>
            <div class="row2">
              <p v-if="dayNum > 2">AGP图谱</p>
              <div id="agp-chart">
              </div>
            </div>
          </div>
        </div>

        <div class="footer" v-if="pageTwoOpen">
          <hr />
          <table>
            <tr>
              <td width="45%">报告者：</td>
              <td>审核者：</td>
              <td class="right">报告日期：</td>
            </tr>
          </table>
        </div>

        <!-- 第二页报告 -->
        <div :key="pos" v-for="(pos, pageIndex) in chartIndexStart" v-show="pageIndex < totalPage" class="page"
          style="page-break-before: always" v-if="pageThrOpen">
          <div class="title">
            <p>{{ org_name }}</p>
            <p>持续葡萄糖监测（CGM）每日报告</p>
          </div>
          <div class="table-head">
            <table>
              <tr>
                <td width="20%">姓名：{{ patient_info.Name }} </td>
                <td width="25%">性别：{{ patient_info.Sex }}</td>
                <td>年龄：{{ patient_info.Age }}</td>
                <td>手机号：{{ patient_info.Mobile }}</td>
              </tr>
              <tr>
                <td>科室：{{ patient_info.Dept }}</td>
                
                <td>住院号/门诊号：{{ patient_info.AdmitNo }} </td>
                <td>床号:{{patient_info.bed  }}</td>
              </tr>
              <tr>
                <td colspan="2">监测周期：{{ time_range }} </td>
                <td>临床诊断：{{ patient_info.Diag }}</td>
                <td>报告编号：{{ reportNum }}</td>
              </tr>
            </table>
          </div>
          <hr />
          <!-- CGM图 -->
          <div class="chart-wrap">
            <div :key="item.title" v-for="(item, index) in ds_title.slice(pos, pos + 7)">
              <p>{{ item.title }} &nbsp; 平均值：{{ item.avg }} mmol/L TIR：{{ item.TIR }}</p>
              <div class="chart" :id="'chart' + (index + pos)">
              </div>
              <div :id="'event' + (index + pos)" class="event-list">
                <p class="event-title">事件：</p>
               
                 <el-tooltip v-for="(data, carbIndex) in event['carb'][index]" :key="carbIndex + Math.random()"
                  effect="dark" :content="getCarb(data)" placement="top-start">
                  <img src="../assets/Hcp-icon/legend/automode/icon_event_carb.png" class="carb img" />
                </el-tooltip>

                <el-tooltip v-for="(data, exeriseIndex) in event['exercise'][index]" :key="exeriseIndex + Math.random()"
                  effect="dark" :content="getExerciseTooltip(data)" placement="top-start">
                  <img src="../assets/Hcp-icon/legend/automode/icon_event_exercise.png" class="exe img" />
                </el-tooltip>


                <el-tooltip v-for="(data, insIndex) in event['ins'][index]" :key="insIndex + Math.random()" effect="dark"
                  :content="getInstip(data)" placement="top-start">
                  <img src="../assets/Hcp-icon/legend/automode/icon_event_insulin.png" class="ins img" />
                </el-tooltip>
              </div>
            </div>
            <div>
              <div class="xx_legend-wrap" v-if="false">
                <div>
                  <img src="../assets/Hcp-icon/legend/transmitter.png"><span>新探头</span>
                </div>
                <div>
                  <img src="../assets/Hcp-icon/legend/warm up.png"><span>初始化</span>
                </div>
                <div>
                  <img src="../assets/Hcp-icon/legend/SG.png"><span>血糖读数</span>
                </div>
                <div>
                  <img src="../assets/Hcp-icon/legend/hypo.png"><span>低限</span>
                </div>
                <div>
                  <img src="../assets/Hcp-icon/legend/target.png"><span>目标范围</span>
                </div>
                <div style="clear: both;margin-left: 0;float: none;">
                </div>
                <div style="margin-left: 0">
                  <img src="../assets/Hcp-icon/legend/calib.png"><span>校准</span>
                </div>
                <div>
                  <img src="../assets/Hcp-icon/legend/calibrate_1.png"><span>指间血糖</span>
                </div>
                <div>
                  <img src="../assets/Hcp-icon/legend/SG.png"><span>餐食</span>
                </div>
                <div>
                  <img src="../assets/Hcp-icon/legend/SG.png"><span>运动</span>
                </div>

              </div>

              <div class="legend-wrap">
                <img src="../assets/Hcp-icon/legend/automode/daily_legend.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="footer" v-if="pageThrOpen">
          <hr />
          <table>
            <tr>
              <td width="45%">报告者：</td>
              <td>审核者：</td>
              <td class="right">报告日期：</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!--container结束-->
</template>

<script>
import * as echarts from 'echarts';
import auth from '../auth/auth'
export default {
  data() {
    return {
      org_name: sessionStorage.getItem('org_name'),
      event: [], loading: true,
      followID: sessionStorage.getItem('followID'),
      target_high: +sessionStorage.getItem('high_glucose'),
      target_low: +sessionStorage.getItem('low_glucose'),
      endHour: +sessionStorage.getItem('endHour'),
      startHour: +sessionStorage.getItem('startHour'),
      startTime: 0,
      endTime: 0,
      patient_info: {},
      info: {},
      time_range: '-',
      date_list: [],
      statistics: [],
      report_date: '',
      ds_title: [
        { avg: '-' },
        { avg: '-' },
        { avg: '-' },
        { avg: '-' },
        { avg: '-' },
        { avg: '-' },
        { avg: '-' }],
      sg_data: [],
      bg_data: [],
      ts: [],
      isMg: false,
      DataS: {
        blos_high: +sessionStorage.getItem('high_glucose') || 8.9,
        blos_low: +sessionStorage.getItem('low_glucose') || 3.9,
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '11',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [20, 0, 0, 930],
      sgMax: 25,
      grid: { x: '5%', y: '13%', width: '92%', height: '60%', top: '19' },
      grid2: { x: '5%', y: '13%', width: '92%', height: '60%', },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      startRender: false,

      XTimeMin: 0,
      XTimeMax: 0,
      XData: [],

      YDataMin: [],
      YDataMax: [],
      YDataMed: [],
      YData10P: [],
      YDataQ1: [],
      YDataQ3: [],
      YData90P: [],

      //  AGP 图表的统计
      AGPStat: {
        cgmUse: '-',
        avgSD: '-',
        hba1c: '--',
        cv: '-',
        avgMage: '-',
        avgModd: '-',
        highDistPercent: '-',
        targetDistPercent: '-',
        lowDistPercent: '-',
        highSGNum: '-',
        lowSGNum: '-',
      },
      chartIndexStart: [],
      target_ge_10: "",
      target_bt_3d9_10: "",
      target_le_3d9: "",
      totalPage: 3,
      event:{},
      bg:[],
      reportNum: '',
      //reportTotal
      total_stat: {
        'num': ['-'],
        'avg': ['-'],
        'sd': ['-'],
        'cv': ['-'],
        'mage': ['-'],
        'max': ['-'],
        'min': ['-'],
        'ge_13d9': ['-'],
        'ge_10': ['-'],
        'ge_7d8': ['-'],
        'le_3d9': ['-'],
        'le_2d8': ['-'],
        'bt_3d9_10': ['-']
      },
      // 打印相关
      printLoading: false,
      printObj: {
        id: "printMe",
        preview: false,
        previewTitle: "print Title", // The title of the preview window. The default is 打印预览
        popTitle: "good print",
        extraCss:
          "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      dayNum: 0,
      target_veryhigh :13.9,
      target_verylow:3.0,
      target_over_13d9:'',
      target_low_3:'',

    }
  },
  computed: {
    getLanguage() {

    },
    pageOneOpen() {
      let params = sessionStorage.getItem('hcgm_report_params')
      if (params) {
      
        return JSON.parse(params).radio1
      } else {
        return false
      }
    },
    pageTwoOpen() {

      let params = sessionStorage.getItem('hcgm_report_params')
      if (params) {
    
        return JSON.parse(params).radio2
      } else {
        return false
      }
    },
    pageThrOpen() {
      let params = sessionStorage.getItem('hcgm_report_params')
      if (params) {
        
        return JSON.parse(params).radio3
      } else {
        return false
      }
    }
  },
  created() {

    let req = this.getRequest()

    let report_prams = sessionStorage.getItem('hcgm_report_params')
    report_prams = JSON.parse(report_prams)
    let report_num = localStorage.getItem('hcgm_report_num')
    if (!report_num) {
      report_num = 1;
      localStorage.setItem('hcgm_report_num', report_num);
    } else {
      report_num = parseInt(report_num)
      localStorage.setItem('hcgm_report_num', report_num + 1)
    }
    if (report_prams.patient_info) {
      this.patient_info = report_prams.patient_info;
    }

    function PrefixInteger(num, len) {
      return (Array(len).join('0') + num).slice(-len);
    }

    let endDateTime = new Date(report_prams.endDate).setHours(0, 0, 0, 0) / 1000;
    let dayNum = report_prams.dayNum;
    let startDateTime = endDateTime - (dayNum - 1) * 86400;
    let ts = [];
    for (let i = 0; i < dayNum; i++) {
      ts.push([
        startDateTime + i * 86400,
        startDateTime + i * 86400 + 86400,
      ])
    }
    this.ts = ts;
    let date_list = ts.map(function (e, i) {
      let d = new Date(e[0] * 1000);
      return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
    })
    this.time_range = date_list[0] + '-' + date_list[dayNum - 1] + '(' + dayNum + '天)';
    let d = new Date();
    this.report_date = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
    this.date_list = date_list;
    let ds_title = ts.map(function (e, i) {
      let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      let d = new Date(e[0] * 1000);
      return {
        'title': auth.formatterDate1b(d) + ' ' + week[d.getDay()],
        'avg': '-',
        'TIR': '-'
      }
    });
    this.ds_title = ds_title;

    let title = [
      ['测定次数'],
      ['平均值（MG，mmol/L）'],
      ['标准差（SD，mmol/L）'],
      ['变异系数(CV，%)'],
      ['平均血糖波动幅度（MAGE，mmol/L）'],
      ['最大值（mmol/L）'],
      ['最小值（mmol/L）'],
      [this.target_low + '-' + this.target_high + 'mmol/L（TIR）的时长(小时：分钟)<br/>百分比'],
      ['>13.9mmol/L的时长(小时：分钟)<br/>百分比'],
      ['>' + this.target_high + 'mmol/L的时长(小时：分钟)<br/>百分比'],
      ['>7.8mmol/L的时长(小时：分钟)<br/>百分比'],
      ['<' + this.target_low + 'mmol/L的时长(小时：分钟)<br/>百分比'],
      ['<2.8mmol/L的时长(小时：分钟)<br/>百分比'],
    ];
    let statistics = title.map(function (e, i) {
      let c = new Array(ts.length).fill('-');
      return e.concat(c)
    });
    this.statistics = statistics;

    this.$http.post('/api/v2.1/data/' + report_prams.uid, {
      sg: {
        ts: ts
      },
      calib: {
        ts: ts
      },
      event: {
        ts: ts
      }
    }).then(function (res) {
      if (0 === res.data.error) {
        const events = res.data.data.event
        let dayEvent = {}
        let carbs = []
        let exercises = []
        let ins = []
        let bg = []
        
        if (events) {
          events.map((d, n) => {
            carbs[n] = []
            exercises[n] = []
            ins[n] = []
            bg[n] = []
            if (d.length > 0) {
              
              d.map(e => {
                dayEvent = {
                  start: e[1],
                  type: e[2]
                }
                
                let content = e[3];
                // 目前只处理运动和carb事件
                if (e[2] === 'EXR' && content.value) {
                  dayEvent['value'] = content.value
                  dayEvent['exetype'] = content.exerciseType
                  exercises[n].push(dayEvent)
                }
                else if (e[2] === 'INS' && content.value) {
                  dayEvent['value'] = content.value
                  dayEvent['instype'] = content.insulinType
                  dayEvent['insName'] = content.name
                  ins[n].push(dayEvent)
                }
                else if (e[2] === 'BG' && content.value) {
                  dayEvent['value'] = content.value
                  dayEvent['note'] = content.note
                  bg[n].push(dayEvent)
                } else if (e[2] === 'CARB' && content.value) {
                  dayEvent['value'] = content.value
                  dayEvent['name'] = content.name
                  carbs[n].push(dayEvent)
                }

                else if (content.value) {
                  dayEvent['value'] = content.value
                  if ('AutoExercise' === e[2]) {
                    exercises[n].push(dayEvent)
                  } 
                }
              })
            }
          })
        }
        this.event = {
          carb: carbs,
          exercise: exercises,
          ins: ins,
          bg, bg
        }
        
        console.log( this.event)
        let day_num = res.data.data.sg.length;
        this.startTime = ts[0][0] + this.startHour * 3600
        this.endTime = ts[day_num - 1][0] + this.endHour * 3600
        if (7 == day_num) {
          this.totalPage = 1;
        }
        // 报告编号
        let curDate = new Date();
        this.reportNum = auth.formatterDate1c(curDate) + '-' + PrefixInteger(report_num, 2);
        // 过滤小时范围内的数据
        this.sg_data = res.data.data.sg.map((dayData, index) => {
          if (index === 0 && dayData.length) {
            return dayData.filter(item => {
              return item[1] > this.startTime
            })
          } else if (index === day_num - 1 && dayData.length) {
            return dayData.filter(item => {
              return item[1] < this.endTime
            })
          } else {
            return dayData
          }
        });
        let cali_data = res.data.data.calib.map((dayData, index) => {
          if (index === 0 && dayData.length) {
            return dayData.filter(item => {
              return item[0] > this.startTime
            })
          } else if (index === day_num - 1 && dayData.length) {
            return dayData.filter(item => {
              return item[0] < this.endTime
            })
          } else {
            return dayData
          }
        });
        res.data.data.event.map((dayData, index) => {   
          this.bg.push([])
          if(dayData.length>0){
            dayData.map((e)=>{
              if(e[2]=='BG'){
                let value =e[3].value?(e[3].value/18).toFixed(1):''
                if(e[3].glucoseType==0){
                  cali_data[index].push([
                  e[1],value,e[3].glucoseType
                ])
                }else{
                  this.bg[index].push([
                  e[1],value,e[3].glucoseType
                ])
                }
               
              }
            })
          }
        });
        console.log('cali_data', this.bg)
        this.bg_data = cali_data;
        this.calStatistics(this.sg_data);
        auth.getDashboardSg(this, this.sg_data);
        this.prepareAGPData(this.sg_data);
        // DS -- daily summary
        this.prepareDSData(this.sg_data);
        this.startRender = true;
        this.$nextTick(() => {
         
          this.drawAGPChart()
          for (let i = 0; i < this.dayNum; i++) {
            this.drawCGMChart(i);
          }
          this.loading = false
          setTimeout(()=>{
            this.makeCarb(this.dayNum, ts[0][0])
          },500)
        })
      }
    })
  },
  methods: {
    getCarb(data){
      if (data) {
        let date = new Date(data.start * 1000)
        let time = this.getTooltipTime(date)
        
        let name = data.name||''
         let value = data.value + ' g'
         return name + '  ' + time + value
      }
    },
    getExerciseTooltip(data) {
      if (data) {
        let date = new Date(data.start * 1000)
        let time = this.getTooltipTime(date)
        
        let type = data.exetype
        const hour = Math.floor(data.value / 60)
        const minutes = Math.floor(data.value % 60)
        let duration = ''
        if (hour > 0) {
          duration += (hour + 'h')
        }
        if (minutes !== 0 || hour === 0) {
          duration += (minutes + 'min')
        }
        return type + '  ' + time + duration
      }
    },
    getInstip(data){
      if (data) {
        let date = new Date(data.start * 1000)
        let time = this.getTooltipTime(date)
        let arr = ['未选择', '速效', '短效', '中效', '长效', '预混']
        let type = arr[data.instype]||'未选择'
        let name =data.insName
        const hour = Math.floor(data.value / 60)
        const minutes = Math.floor(data.value % 60)
        let duration = ''
        if (hour > 0) {
          duration += (hour + 'h')
        }
        if (minutes !== 0 || hour === 0) {
          duration += (minutes + 'min')
        }
        return name+ '  '+type + '  ' + time + duration
      }
    },
    getTooltipTime(date) {
      const hour = date.getHours()
      const minute = date.getMinutes()
      return `00${hour}`.slice(-2) + ': ' + `00${minute}`.slice(-2) + '; '
    },
    makeCarb(dayNum, startTime) {
      
      let events = this.event
      let carbClassName = 'event-item'
      for (let i = 0; i < dayNum; i++) {
        let id = 'event' + i
        let time = startTime + i * 86400
        const OBJ = document.getElementById(id);
        if (events['carb'][i].length && OBJ) {
          events['carb'][i].map((item, index) => {
            let el = OBJ.getElementsByClassName('carb')[index]
            // left要缩放0.96 864/0.96=900
            let w = ((item.start - time) / 900).toFixed(1) + '%'
            if (el) {
              el.style.left = w
            }
          })
        }
        if (events['exercise'][i].length && OBJ) {
          events['exercise'][i].map((item, index) => {
            let el = OBJ.getElementsByClassName('exe')
            let w = ((item.start - time) / 900).toFixed(1) + '%'
            if (el[index]) {

              el[index].style.left = w
           
            }
          })
        }        
        if (events['ins'][i].length && OBJ) {
          events['ins'][i].map((item, index) => {
            let el = OBJ.getElementsByClassName('ins')
            let w = ((item.start - time) / 900).toFixed(1) + '%'
            if (el[index]) {

              el[index].style.left = w
           
            }
          })
        }
      }
    },
    printPdf() {

      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        let hkey_path;
        hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
        try {
          let RegWsh = new ActiveXObject("WScript.Shell");
          RegWsh.RegWrite(hkey_path + "header", "");
          RegWsh.RegWrite(hkey_path + "footer", "");
        } catch (e) { }
      }
      document.getElementsByClassName('noprint')[0].style.opacity = 0
      document.getElementsByClassName('noprint')[1].style.opacity = 0
      document.title = this.patient_info.Name + this.time_range
      setTimeout(() => {
        window.print()
        document.getElementsByClassName('noprint')[0].style.opacity = 1
        document.getElementsByClassName('noprint')[1].style.opacity = 1
      }, 300)

    },
    routeBack() {
      this.$router.go(-1);
    },
    calMAGE(data, index) {

      let logFlag = false;
      data = data.map(function (e, i) {
        return [i, e];
      })

      if (data.length == 0) {
        return '-';
      }
      let data2 = data.map(function (e, i) {
        return e[1];
      })
      let avgSD = auth.getAvgSD(data2);
      let sd = avgSD.sd;
      let max = Math.max.apply(Math, data2);
      let min = Math.min.apply(Math, data2);
      let trend = ''

      function filterSame(data) {
        if (data.length < 3) {
          return data;
        }
        let res = []
        res.push(data[0]);
        for (let i = 1; i < data.length; i++) {
          if (data[i][1] == data[i - 1][1]) {
            continue;
          }
          res.push(data[i])
        }
        return res
      }
      function filterNotPeak(data) {
        if (data.length < 3) {
          return data;
        }
        let res = []
        res.push(data[0]);
        for (let i = 1; i < data.length - 1; i++) {
          if ((data[i][1] > data[i - 1][1]) && (data[i][1] > data[i + 1][1])) {
            res.push(data[i]);
          } else if ((data[i][1] < data[i - 1][1]) && (data[i][1] < data[i + 1][1])) {
            res.push(data[i]);
          }
        }
        res.push(data[data.length - 1]);
        return res;
      }

      function filterOneSide(data, sd, max, min) {

        let procLoop = 10;

        let res = [];
        let resFilter = [];
        for (let p = 0; p < procLoop; p++) {
          if (data.length < 3) {
            return data;
          }
          res = [];
          res.push(data[0]);
          for (let i = 1; i < data.length - 1; i++) {
            if ((data[i][1] == max) || (data[i][1] == min)) {
              res.push(data[i])
              continue
            }
            let leftSide = Math.abs(data[i][1] - data[i - 1][1]);
            let rightSide = Math.abs(data[i][1] - data[i + 1][1]);
            if (leftSide >= sd || rightSide >= sd) {
              res.push(data[i])
            } else if (i == 1) {
              if ((data[i][1] < data[i - 1][1]) && (true) && (data[i][1] <= data[i + 2][1])) {
                res.push(data[i])
              } else if ((data[i][1] > data[i - 1][1]) && (true) && (data[i][1] >= data[i + 2][1])) {
                res.push(data[i]);
              }
            } else if (i == (data.length - 1 - 1)) {
              if ((data[i][1] < data[i - 1][1]) && (data[i][1] <= data[i - 2][1]) && (true)) {
                res.push(data[i])
              } else if ((data[i][1] > data[i - 1][1]) && (data[i][1] >= data[i - 2][1]) && (true)) {
                res.push(data[i]);
              }
            } else if ((i >= 2) && (i <= (data.length - 1 - 2))) {
              if ((data[i][1] < data[i - 1][1]) && (data[i][1] <= data[i - 2][1]) && (data[i][1] <= data[i + 2][1])) {
                res.push(data[i])
              } else if ((data[i][1] > data[i - 1][1]) && (data[i][1] >= data[i - 2][1]) && (data[i][1] >= data[i + 2][1])) {
                res.push(data[i]);
              }
            }
          }
          res.push(data[data.length - 1]);
          let resFilterSame = filterSame(res)
          resFilter = filterNotPeak(resFilterSame)
          if (resFilter.length == data.length) {
            break;
          }
          data = resFilter;
        }
        return resFilter;
      }

      function filterTwoSide(data, sd, max, min) {

        let procLoop = 10;

        let res = [];
        let resFilter = [];
        for (let p = 0; p < procLoop; p++) {
          if (data.length < 3) {
            return data;
          }
          res = [];
          for (let i = 0; i < data.length; i++) {
            if ((data[i][1] == max) || (data[i][1] == min)) {
              res.push(data[i])
              continue
            }
            if (0 == i) {
              let rightSide = Math.abs(data[i][1] - data[i + 1][1]);
              if (rightSide >= sd) {
                res.push(data[0]);
              }
            } else if (data.length - 1 == i) {
              let leftSide = Math.abs(data[i][1] - data[i - 1][1]);
              if (leftSide >= sd) {
                res.push(data[data.length - 1]);
              }
            } else {
              let leftSide = Math.abs(data[i][1] - data[i - 1][1]);
              let rightSide = Math.abs(data[i][1] - data[i + 1][1]);
              if (leftSide >= sd && rightSide >= sd) {
                res.push(data[i])
              } else if (i == 1) {
                if ((data[i][1] < data[i - 1][1]) && (true) && (data[i][1] <= data[i + 2][1])) {
                  res.push(data[i])
                } else if ((data[i][1] > data[i - 1][1]) && (true) && (data[i][1] >= data[i + 2][1])) {
                  res.push(data[i]);
                }
              } else if (i == (data.length - 1 - 1)) {
                if ((data[i][1] < data[i - 1][1]) && (data[i][1] <= data[i - 2][1]) && (true)) {
                  res.push(data[i])
                } else if ((data[i][1] > data[i - 1][1]) && (data[i][1] >= data[i - 2][1]) && (true)) {
                  res.push(data[i]);
                }
              } else if ((i >= 2) && (i <= (data.length - 1 - 2))) {
                if ((data[i][1] < data[i - 1][1]) && (data[i][1] <= data[i - 2][1]) && (data[i][1] <= data[i + 2][1])) {
                  res.push(data[i])
                } else if ((data[i][1] > data[i - 1][1]) && (data[i][1] >= data[i - 2][1]) && (data[i][1] >= data[i + 2][1])) {
                  res.push(data[i]);
                }
              }
            }

          }
          let resFilterSame = filterSame(res)
          resFilter = filterNotPeak(resFilterSame)
          if (resFilter.length == data.length) {
            break;
          }
          data = resFilter;
        }
        return resFilter;
      }

      function filterStartEnd(data, sd, max, min) {
        if (data.length <= 1) {
          return [];
        }
        if (2 == data.length) {
          if (Math.abs(data[0][1] - data[1][1]) < sd) {
            return []
          } else {
            return data;
          }
        }
        if ((Math.abs(data[0][1] - data[1][1]) < sd) && (data[0][1] != max) && (data[0][1] != min)) {
          data = data.slice(1);
        }
        let size = data.length;
        if ((Math.abs(data[size - 1][1] - data[size - 2][1]) < sd) && (data[size - 1][1] != max) && (data[size - 1][1] != min)) {
          data = data.slice(0, size - 1);
        }
        return data;
      }

      let proc = filterSame(data);
      proc = filterNotPeak(proc);
      proc = filterOneSide(proc, sd, max, min)
      proc = filterStartEnd(proc, sd, max, min);
      proc = filterTwoSide(proc, sd, max, min);
      proc = proc.map(function (e, i) {
        return e[1];
      })
      if (proc.length > 1) {
        let total = 0;
        for (let i = 0; i < proc.length - 1; i++) {
          total += Math.abs(proc[i] - proc[i + 1]);
        }
        let mage = total / (proc.length - 1);
        return mage;
      }
      return '-';
    },
    calModd(sg_proc) {

      let dayNum = sg_proc.length;
      let data = [];

      for (let i = 0; i < 720; i++) {
        let dayList = [];
        for (let d = 0; d < dayNum; d++) {
          dayList.push(-1);
        }
        data.push(dayList);
      }

      for (let d = 0; d < dayNum; d++) {
        for (let i = 0; i < sg_proc[d].length; i++) {
          let p = sg_proc[d][i];
          let t = new Date(p[0] * 1000);
          let m = t.getHours() * 60 + t.getMinutes();
          let index = Math.floor(m / 2);
          if (index >= 720) {
          }
          if (-1 == data[index][d]) {
            data[index][d] = p[1];
          }
        }
      }

      let diff = [];
      let diff_debug = [];
      data.map(function (e, i) {

        for (let n = 1; n < e.length; n++) {
          if (e[n] != -1 && e[n - 1] != -1) {
            diff.push(Math.abs(e[n] - e[n - 1]));
            diff_debug.push([i, n, Math.abs(e[n] - e[n - 1]) * 18.0])
          }
        }
      })
      let res = auth.getAvgSD(diff);
      if (diff.length > 0) {
        this.AGPStat.avgModd = res['avg'].toFixed(1) + 'mmol/L';
      }

    },
    calStatistics(sg_data) {

      let dayNum = sg_data.length;
      let sg_proc = sg_data.map(function (day_records, d) {
        let day_proc = [];
        for (let i = 0; i < day_records.length; i++) {
          let s = day_records[i];
          if (((s[4] == 'C') || (s[4] == 'NC') || (s[4] == 'CX')) && (s[3] > 0.1)) {
            let val = s[3];
            val = (val > 22.2) ? 22.2 : val;
            val = (val < 2.2) ? 2.2 : val;
            day_proc.push(val)
          }
        }
        return day_proc;
      })
      // 统计计算
      let row = ['num', 'avg', 'sd', 'cv', 'mage', 'max', 'min',
        'bt_3d9_10', 'ge_13d9', 'ge_10', 'ge_7d8', 'le_3d9', 'le_2d8']
      let that = this

      function calSGStat(value, flag) {
        function fillPreZero(s, num) {
          let pre = '';
          let lack = 0;
          if (s.length >= num) {
            lack = 0;
          } else {
            lack = num - s.length;
          }
          for (let i = 0; i < lack; i++) {
            pre += '0';
          }
          return pre + s;
        }
        function minite_format(m, total, flag) {
          let percent = (m * 100.0 / total).toFixed(1);
          if (1 == flag) {
            return '%h小时%m分钟（%p%）'.
              replace('%h', Math.floor(m / 60)).
              replace('%m', (m % 60)).
              replace('%p', (percent));
          }
          return '%h:%m<br/>%p%'.
            replace('%h', fillPreZero(Math.floor(m / 60) + '', 2)).
            replace('%m', fillPreZero((m % 60) + '', 2)).
            replace('%p', percent);
        }
        function percent_format(m, total) {
          let percent = (m * 100.0 / total).toFixed(1) + '%';
          return percent
        }

        let res_dict = {}
        let sg_value = value;
        let size = sg_value.length;
        res_dict['num'] = size;
        if (size) {
          res_dict['max'] = Math.max.apply(null, sg_value).toFixed(1);
          res_dict['min'] = Math.min.apply(null, sg_value).toFixed(1);
          let avg_sd = auth.getAvgSD(sg_value)
          if (avg_sd.num) {
            res_dict['avg'] = avg_sd.avg.toFixed(1);
            res_dict['sd'] = avg_sd.sd.toFixed(1);
            // print 'avg_sd:', avg_sd
            if (avg_sd.num && avg_sd.avg > 0.1) {
              let cv = parseFloat(avg_sd.sd.toFixed(1)) / parseFloat(avg_sd.avg.toFixed(1));   // sd/avg
              res_dict['cv'] = (cv * 100).toFixed(1) + '%'
            }
          }
          if (avg_sd.num < 72) {
            res_dict['sd'] = '-'
            res_dict['cv'] = '-'
          }
        } else {
          res_dict['max'] = '-';
          res_dict['min'] = '-';
          res_dict['avg'] = '-';
          res_dict['sd'] = '-';
          res_dict['cv'] = '-';

        }
        res_dict['mage'] = '-';

        // #
        let ge_13d9 = [];
        let ge_10 = [];
        let ge_7d8 = [];
        let le_3d9 = [];
        let le_2d8 = [];
        let bt_3d9_10 = [];
        let le_3 =[]
        let ge_ov13d9 =[]
        let ge_ov10=[]
        let ge_be3d9=[]
        sg_value.map(function (e, i) {
          if (e > 13.9) {
            ge_13d9.push(e);
          }
          if(e>=13.9){
            ge_ov13d9.push(e)
          }
          if (e >that.target_high&&e<=13.9) {
            ge_10.push(e);
          }
          if (e >=7.8) {
            ge_7d8.push(e);
          }
          if (e >= that.target_high) {
            ge_ov10.push(e);
          }
          if (e <that.target_low&&e>=3.0) {
            le_3d9.push(e);
          }
          if(e<3.0){
              le_3.push(e)
          }
          if (e <that.target_low) {
            ge_be3d9.push(e);
          }
          if (e <=2.8) {
            le_2d8.push(e);
          }
          if (that.target_low <= e && e <= that.target_high) {
            bt_3d9_10.push(e);
          }
        })

        if (size) {
          that.target_over_13d9 = percent_format(ge_13d9.length * 2, size * 2)
          that.target_ge_10 = percent_format(ge_10.length * 2, size * 2)
          that.target_bt_3d9_10 = percent_format(bt_3d9_10.length * 2, size * 2)
          that.target_le_3d9 = percent_format(le_3d9.length * 2, size * 2)
          that.target_low_3 = percent_format(le_3.length * 2, size * 2)
          res_dict['ge_13d9'] = minite_format(ge_ov13d9.length * 2, size * 2, flag)
          res_dict['ge_10'] = minite_format(ge_ov10.length * 2, size * 2, flag)
          res_dict['ge_7d8'] = minite_format(ge_7d8.length * 2, size * 2, flag)
          res_dict['le_3d9'] = minite_format(ge_be3d9.length * 2, size * 2, flag)
          res_dict['le_2d8'] = minite_format(le_2d8.length * 2, size * 2, flag)
          res_dict['bt_3d9_10'] = minite_format(bt_3d9_10.length * 2, size * 2, flag)
        } else {
          res_dict['ge_13d9'] = '-';
          res_dict['ge_10'] = '-';
          res_dict['ge_7d8'] = '-';
          res_dict['le_3d9'] = '-';
          res_dict['le_2d8'] = '-';
          res_dict['bt_3d9_10'] = '-';
        }
        return res_dict;
      }

      let stat_res = sg_proc.map(function (e, i) {
        let res = calSGStat(e, 0);
        return res;
      })
      // let order = []
      
      for (let d = 0; d < dayNum; d++) {
        for (let i = 0; i < row.length; i++) {
          this.statistics[i][d + 1] = stat_res[d][row[i]];
        }
      }

      let mage = sg_proc.map((e, i) => {
        if (e.length >= 576) {
          return this.calMAGE(e, i);
        } else {
          return '-';
        }

      })

      let totalNormalSG = 0;
      let total_sg = [];
      let avgSD = sg_proc.map((e, i) => {
        totalNormalSG += e.length;
        total_sg = total_sg.concat(e);
        return auth.getAvgSD(e);
      })
      // 全部数据统计
      let total_res = calSGStat(total_sg, 1);
      for (let p in total_res) {
        if (this.total_stat[p]) {
          this.total_stat[p][0] = total_res[p];
        }
      }

      let mageStat = [];
      let mageSum = 0;
      for (let i = 0; i < mage.length; i++) {
        if (typeof (mage[i]) == "number") {
          this.statistics[4][i + 1] = mage[i].toFixed(1);
          mageStat.push(parseFloat(mage[i].toFixed(1)));
          mageSum += parseFloat(mage[i].toFixed(1));
        }
      }
      if (mageStat.length > 0) {
        let avgMage = (mageSum * 1.0 / mageStat.length).toFixed(1);
        this.AGPStat.avgMage = avgMage + 'mmol/L';
      }
      // 计算MODD
      //this.calModd(sg_proc);
    },

    prepareDSData(sg_day) {

      let dayNum = sg_day.length;
      let context = this;
      sg_day.map((d, n) => {
        let day_sg = [];
        let day_target_num = 0;

        if (d.length > 0) {
          d.map((e, i) => {
            if ((e[4] == 'C' || e[4] == 'NC' || e[4] == 'CX') && e[3] > 0.00001) {
              let val = e[3];
              val = (val > 22.2) ? 22.2 : val;
              val = (val < 2.2) ? 2.2 : val;
              day_sg.push(val)

              if (val > this.target_high) {
              } else if (val < this.target_low) {
              } else {
                day_target_num += 1;
              }
            }
          })
        }
        //
        let result = auth.getAvgSD(day_sg);
        if (result.num) {
          context.ds_title[n].avg = result.avg.toFixed(1);
          context.ds_title[n].TIR = (day_target_num * 100.0 / day_sg.length).toFixed(1) + '%';
        }

      })
    },
    calHighLowSGEvent(data, dayNum) {

      let highFlag = false;
      let lowFlag = false;
      let highData = [];
      let lowData = [];
      let highDataList = [];
      let lowDataList = [];
      let highEvent = 0;
      let lowEvent = 0;

      for (let i = 0; i < data.length; i++) {
        let sgValue = data[i][1];
        // 高血糖处理
        if (sgValue > this.target_high) {
          highData.push(data[i])
        } else {
          if (highData.leprepareAGPDatacreatedngth) {
            if (highData.length < 8) {
              highData = []
            } else if (data[i][0] - highData[highData.length - 1][0] > 15 * 60) {
              highDataList.push(highData);
              highData = [];
            }
          }
        }
        // 低血糖处理
        if (sgValue < this.target_low) {
          lowData.push(data[i])
        } else {
          if (lowData.length) {
            if (lowData.length < 8) {
              lowData = []
            } else if (data[i][0] - lowData[lowData.length - 1][0] > 15 * 60) {
              lowDataList.push(lowData);
              lowData = [];
            }
          }
        }
      }
      if (highData.length) {
        highDataList.push(highData);
      }
      if (lowData.length) {
        lowDataList.push(lowData);
      }

      function SplitBy15MinutesGap(data) {
        let res = [];
        let pos = 0;
        for (let i = 1; i < data.length; i++) {
          let gap = data[i][0] - data[i - 1][0];
          if (gap > 15 * 60) {
            let seg = data.slice(pos, i);
            res.push(seg);
            pos = i;
          }
        }
        res.push(data.slice(pos, data.length));
        return res;
      }

      let highRes = [];
      let lowRes = [];
      for (let p = 0; p < highDataList.length; p++) {
        let s = SplitBy15MinutesGap(highDataList[p]);
        highRes = highRes.concat(s);
      }
      for (let p = 0; p < lowDataList.length; p++) {
        let s = SplitBy15MinutesGap(lowDataList[p]);
        lowRes = lowRes.concat(s);
      }

      highRes = highRes.filter(function (e, i) {
        return e.length >= 8;
      })
      lowRes = lowRes.filter(function (e, i) {
        return e.length >= 8;
      })

      highEvent = highRes.length;
      lowEvent = lowRes.length;
      this.AGPStat.highSGNum = (highEvent / (data.length / (720.0))).toFixed(1);
      this.AGPStat.lowSGNum = (lowEvent / (data.length / (720.0))).toFixed(1);

    },
    prepareAGPData(sg_day) {
      let dayNum = sg_day.length;
      this.dayNum = dayNum
      let dataTotalNum = 0;

      let lastDayTime = this.ts[this.ts.length - 1][0];
      let curDate = new Date();
      let curDateStart = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
      let totalDayReal = this.ts.length;
      if (curDateStart.getTime() == lastDayTime * 1000) {
        totalDayReal = (this.ts.length - 1) + ((curDate.getHours() * 60 + curDate.getMinutes()) / 1440.0);

      }
      for (let i = 0; i < totalDayReal; i += 7) {
        this.chartIndexStart.push(i)
      }
      let sg_data = [];
      let sg_data2 = [];
      let sg_data3 = [];
      let sg_high = [];
      let sg_low = [];
      let sg_high_total_num = 0;
      let sg_low_total_num = 0;
      let sg_target_total_num = 0;
      let sg_very_high_total_num =0
      let sg_very_low_total_num =0
      sg_day.map((d, n) => {
        let day_proc = [];
        if (d.length > 0) {
          d.map((e, i) => {
            if ((e[4] == 'C' || e[4] == 'NC' || e[4] == 'CX') && e[3] > 0.00001) {
              let val = e[3];
              val = (val > 22.2) ? 22.2 : val;
              val = (val < 2.2) ? 2.2 : val;
              sg_data.push(val)
              sg_data2.push([e[1], e[3]])
              day_proc.push([e[1], e[3]])
              if (val > 13.9) {
                sg_very_high_total_num += 1
              }
              if (val > this.target_high && val <= 13.9) {
                sg_high_total_num += 1;
              } else if (val >= this.target_low && val <= this.target_high) {
                sg_target_total_num += 1
              }
              else if (val <this.target_low && val >= 3.0) {
                sg_low_total_num += 1;
              } else if (val < 3.0) {
                sg_very_low_total_num += 1;
              }
            }
          })
        }
        sg_data3.push(day_proc);
      })
      dataTotalNum = sg_data.length;

      //
      this.AGPStat.highSGNum = (sg_high_total_num * 1.0 / dayNum).toFixed(1);
      this.AGPStat.lowSGNum = (sg_low_total_num * 1.0 / dayNum).toFixed(1);
      this.calHighLowSGEvent(sg_data2, dayNum);
      this.calModd(sg_data3);

      //
      let result = auth.getAvgSD(sg_data)
      if (result.num) {
        this.AGPStat.avgSD = result.avg.toFixed(1) + '±' + result.sd.toFixed(1)
        this.AGPStat.cv = (parseFloat(result.sd.toFixed(1)) * 100.0 / parseFloat(result.avg.toFixed(1))).toFixed(1) + '%'
        let highDist = (sg_high_total_num * 1.0 / result.num);
        let lowDist = (sg_low_total_num * 1.0 / result.num);
        let veryHighDist = (sg_very_high_total_num * 1.0 / result.num);
        let veryLowDist = (sg_very_low_total_num * 1.0 / result.num);
        let targetDist = 1 - lowDist - highDist - veryHighDist - veryLowDist;
        let highDistPercent = parseFloat((highDist * 100).toFixed(1));
        let lowDistPercent = parseFloat((lowDist * 100).toFixed(1));

        let targetDistPercent = parseFloat((100 - lowDistPercent - highDistPercent).toFixed(1));
        this.AGPStat.highDistPercent = highDistPercent + '%';
        this.AGPStat.lowDistPercent = lowDistPercent + '%';
        this.AGPStat.targetDistPercent = targetDistPercent + '%';
        let highHeight = (highDist * 30);
        this.$nextTick(() => {
          if (document.getElementById('dist_high')) {
            document.getElementById('dist_high').style.height = (highDist * 30).toFixed(1) + 'mm';
            document.getElementById('dist_high').style.backgroundColor = '#ffad00'
          }
          if (document.getElementById('dist_target')) {
            document.getElementById('dist_target').style.height = (targetDist * 30).toFixed(1) + 'mm';
            document.getElementById('dist_target').style.backgroundColor = '#21ca3b'
          }
          if (document.getElementById('dist_low')) {
            document.getElementById('dist_low').style.height = (lowDist * 30).toFixed(1) + 'mm';
            document.getElementById('dist_low').style.backgroundColor = '#ff4e4e'
          }
          if (document.getElementById('dist_very_high')) {
            document.getElementById('dist_very_high').style.height = (veryHighDist * 40).toFixed(1) + 'mm';
            document.getElementById('dist_very_high').style.backgroundColor = '#F58C4A'
          }
          if (document.getElementById('dist_very_low')) {
            document.getElementById('dist_very_low').style.height = (veryLowDist * 40).toFixed(1) + 'mm';
            document.getElementById('dist_very_low').style.backgroundColor = '#9A292F'
          }
          // if (document.getElementById('dist_high_label')) {
          //   document.getElementById('dist_high_label').style.height = (highDist * 30).toFixed(1) + 'mm';
          // }
          // if (document.getElementById('dist_target_label')) {
          //   document.getElementById('dist_target_label').style.height = (targetDist * 30).toFixed(1) + 'mm';
          //   let labelDOM = document.getElementById('dist_target_label')
          //   let labelHeight = parseFloat(labelDOM.style.height)
          //   if (labelHeight < 13) {
          //     [...labelDOM.getElementsByTagName('p')][0].style.top = '-50%'
          //   }
          // }
          // if (document.getElementById('dist_low_label')) {
          //   document.getElementById('dist_low_label').style.height = (lowDist * 30).toFixed(1) + 'mm';
          // }
        })
      }
      this.AGPStat.cgmUse = (sg_data.length * 100.0 / (totalDayReal * 720)).toFixed(1);
      if (result.num >0  && result.avg >0) {
        this.AGPStat.hba1c = ((result.avg * 18.0) * 0.02392 + 3.31).toFixed(1) + '%';
      }
    },
    getRequest() {

      let href = location.href;
      let theRequest = {};
      if (href.indexOf("?") != -1) {
        let search = href.substring(href.indexOf("?") + 1)
        let strs = search.split("&");
        for (let i = 0; i < strs.length; i++) {
          let pair = strs[i].split("=");
          theRequest[pair[0]] = unescape(pair[1]);
        }

      }
      return theRequest;
    },
    drawAGPChart() {
      if (!this.pageTwoOpen) return
      if (this.dayNum > 2) {
        let sel_time = new Date(2019, 0, 1).getTime();
        this.XTimeMin = sel_time;
        this.XTimeMax = sel_time + 86400 * 1000;
        let that = this;
        this.chart1_4 = echarts.init(document.getElementById('agp-chart'), null, { renderer: 'svg' });
        this.chart1_4.setOption({
          title: {
            text: '血糖值（mmol/L）',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              label: {
                backgroundColor: '#6a7985'
              }
            },
            formatter: function (params, ticket, callback) {
              if (params instanceof Array) {
                let paramSize = params.length;
                let strMinute = params[0].axisValueLabel;
                let strTooptip = strMinute.slice(0, 5);
                let t = new Date(params[0].axisValue);
                let minute = t.getHours() * 60 + t.getMinutes();
                let startMinute = minute - 5;
                let endMinute = minute + 5;
                function minuteFormat(minute) {
                  let h = Math.floor(minute / 60);
                  let m = Math.floor(minute % 60);
                  if (h < 10) {
                    h = '0' + h;
                  }
                  if (m < 10) {
                    m = '0' + m;
                  }
                  return h + ':' + m;
                }
                strTooptip = minuteFormat(startMinute) + ' ~ ' + minuteFormat(endMinute);
                for (let i = paramSize - 1; i >= 0; i--) {
                  let series = params[i];
                  strTooptip += '<br/>' + series.seriesName + ': ' + series.value[2]
                }
                return strTooptip;
              }
              return 'Loading';
            }
          },
          xAxis: [{
            type: 'time',
            interval: 3600 * 1000,
            min: this.XTimeMin,
            max: this.XTimeMax,
            splitNumber: 24,
            axisLabel: {
              show: true, interval: 2,
              formatter: function (value, index) {
              
                if (index === 0) return
                let minute = index * 30;
                function PrefixInteger(num, len) {
                  return (Array(len).join('0') + num).slice(-len);
                }
                let texts = [PrefixInteger(minute / 30, 2) - 1, PrefixInteger(minute % 30, 2)];
                if ((index - 1) % 3 == 0) {
                  return texts.join(':');

                } else {
                  return '';
                }

              }
            },
            axisLine: { lineStyle: { color: '#000' } },
          }],

          yAxis: [
            {
              type: 'value',
              min: 0,
              max: this.sgMax,
              axisLabel: this.yAxisLabel,
              axisLine: { lineStyle: { color: '#ccc' } },
              boundaryGap: false,
              axisTick: { length: 0 },
            },

            {
              type: 'value',
              min: 0,
              max: this.sgMax,
              axisLabel: { show: false },
              axisLine: { lineStyle: { color: '#ccc' } },
              boundaryGap: false,
              axisTick: { length: 0 },
            }
          ],
          grid: this.grid2,

          legend: {
            selectedMode: false,
            itemWidth: 40,
            itemHeight: 15,
            itemGap: 25,
            symbolKeepAspect: false,
            bottom: 30,
            formatter: function (name) {
              if ('50%' == name) {
                return '50%(中位数)';
              } else if ('25%' == name) {
                return '25% - 75%';
              } else if ('5%' == name) {
                return '5% - 95%';
              } else if ('Min' == name) {
                return '最大/最小值'
              } else if ('Max' == name) {
                return '目标范围'
              }

              return name;
            },
            data: [{
              name: '50%', icon: 'image://static/dashboardLegend/Medium.png'
            }, //'50%', '25%', '10%', 'Min', 'Max'
            {
              name: '25%', icon: 'image://static/dashboardLegend/IQR.png'
            },
            {
              name: '5%', icon: 'image://static/dashboardLegend/10_90.png'
            },
            {
              name: 'Min', icon: 'image://static/dashboardLegend/Min_Max.png'
            },
            {
              name: 'Max', icon: 'image://static/dashboardLegend/TargetRange.png'
            },
            ],
          },
          series: [
            {
              name: 'Min',
              type: 'line',
              data: this.YDataMin,
              stack: 'total',
              lineStyle: {
                normal: {
                  color: '#979797',
                  width: 1,
                  type: 'dashed'
                }
              },
              symbol: 'none',
              markArea: {
                data: [
                  [{ yAxis: (this.isMg) ? this.target_low * 18 : this.target_low }, { yAxis: (this.isMg) ? this.target_high * 18 : this.target_high }]
                ],
                tooltip: { show: false },
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
            },
            {
              name: '5%',
              type: 'line',
              data: this.YData10P,
              stack: 'total',
              symbol: 'none',
              lineStyle: {
                normal: {
                  color: 'rgba(140, 201, 239, 0.5)',
                  width: 1
                }
              }

            },
            {
              name: '25%',
              type: 'line',
              data: this.YDataQ1,
              stack: 'total',
              areaStyle: {
                normal: {
                  color: 'rgba(140, 201, 239, 0.5)',
                }
              },
              lineStyle: {
                normal: {
                  color: 'rgba(62, 176, 245, 0.6)',
                  width: 1
                }
              },
              symbol: 'none',

            },
            {
              name: '50%',
              type: 'line',
              data: this.YDataMed,
              stack: 'total',
              areaStyle: {
                normal: { color: 'rgba(62, 176, 245, 0.6)', }
              },
              lineStyle: {
                normal: {
                  color: '#505050',
                  width: 1
                }
              },
              symbol: 'none',
            },

            {
              name: '75%',
              type: 'line',
              data: this.YDataQ3,
              stack: 'total',
              areaStyle: { normal: { color: 'rgba(62, 176, 245, 0.6)', } },
              lineStyle: {
                normal: {
                  color: 'rgba(62, 176, 245, 0.6)',
                  width: 1
                }
              },
              symbol: 'none',
            },
            {
              name: '95%',
              type: 'line',
              data: this.YData90P,
              stack: 'total',
              areaStyle: { normal: { color: 'rgba(140, 201, 239, 0.5)', } },
              lineStyle: {
                normal: {
                  color: 'rgba(62, 176, 245, 0.6)',
                  width: 1
                }
              },
              symbol: 'none',
            },
            {
              name: 'Max',
              type: 'line',
              data: this.YDataMax,
              stack: 'total',
              lineStyle: {
                normal: {
                  color: '#979797',
                  width: 1,
                  type: 'dashed'
                }
              },
              symbol: 'none',
            },
          ],
        })
      }
    },
    drawCGMChart(index) {
      if (!this.pageThrOpen) return
      let i = index;
      let chartId = 'chart' + index;
      let charHandle = echarts.init(document.getElementById(chartId), null, { renderer: 'svg' });
      let chart_st = new Date(this.ts[i][0] * 1000);
      let chart_et = new Date(this.ts[i][1] * 1000);
      let chart_sleepTime = [
        [
          new Date((this.ts[i][0] + 3600 * 23) * 1000),
          chart_et,
          25
        ],
        [
          chart_st,
          new Date((this.ts[i][0] + 3600 * 6) * 1000),
          25
        ],
      ]
      let day_sg = this.sg_data[i];
      let chart_sg = [];
      for (let i = 0; i < day_sg.length; i++) {
        if (day_sg[i][4] == 'C' && day_sg[i][3] < 0.1) {
          continue;
        }
        if(day_sg[i][4] == 'H'){
          day_sg[i][3] = 0.0;
        }
        chart_sg.push([
          new Date(day_sg[i][1] * 1000),
          parseFloat(day_sg[i][3].toFixed(1)),
          day_sg[i][4],
        ])
      }
      let day_bg = this.bg_data[i];
      let bgarr = this.bg[i]
      let bg_calib =[]
      for (let m = 0; m < bgarr.length; m++) {
        bg_calib.push([
          new Date(bgarr[m][0] * 1000),
          bgarr[m][1],
        ])
      }
      let chart_calib = [];
      for (let n = 0; n < day_bg.length; n++) {
        chart_calib.push([
          new Date(day_bg[n][0] * 1000),
          day_bg[n][1],
        ])
      }
      let that = this;
      charHandle.setOption({
        title: {
          text: (this.isMg) ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333', }
          },
          textStyle: {
            color: '#ffffff'
          },
          backgroundColor: '#555',
          formatter: function (params) {
            let tip = auth.formatterTip1(params, that, 'ds');
            return tip;
          },
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: chart_st,
          max: chart_et,
          offset: 20,
          axisLabel: {
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function (value, index) {
              let H = new Date(value).getHours();
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? ('0' + H + ':00') : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },

          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          axisPointer: { snap: true }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 },
        }],
        grid: this.grid,
        series: [
          {
            name: 'SG',
            type: 'scatter',
            data: chart_sg,
            markArea: {
              data: [
                [{ yAxis: this.target_low },
                { yAxis: this.target_high }]
              ],
              tooltip: { show: false },
              itemStyle: {
                normal: {
                  color: 'rgba(211,255,213,0.6)',
                }
              }
            },
            markLine: {
              data: [{ yAxis: 3.1 }],
              symbol: ['circle', 'circle'],
              silent: true,
              symbolSize: 1,
              lineStyle: {
                normal: {
                  color: 'rgba(255,0,0,0.5)',
                  type: 'solid',
                }
              },
              label: { normal: { show: false } },
            },
            itemStyle: {
              normal: {
                color: (params) => {
                  let color = '#2cd200';
                  if ( params.value[2] === 'H') {
                    color = '#a4a4a4';
                  }
                  else {
                    {
                      if (params.value[1] > this.target_high) { color = '#e6be00' }
                      if (params.value[1] < this.target_low) { color = '#ff5c5c' }
                    }
                  }
                  let type = params.value[2];
                  if ((type === 'NC' && params.value[1] == 0) || type === 'DE' || type === 'CE0' || type === 'CE1') {
                    color = 'transparent';
                  }
                  return color;
                }
              }
            },
            tooltip: {
              backgroundColor: '#333',
              formatter: function (params) {
                let date = params.value[0];
                let time = auth.formatterDate5(date);
                if (params.value[1] > 0) {
                  if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                    return time[0] + ':' + time[1] + ', ' + params.value[1].toFixed(1) +
                      '<hr style="width: 20px;background:#FFF;height:1px;border:none;margin-left: 42px;">';
                  }
                  return time[0] + ':' + time[1] + ', ' + params.value[1].toFixed(1);
                }
                else {
                  if (params.value[2] === 'NC') {
                    return time[0] + ':' + time[1] + ', Not Calibrated';
                  }
                  if (params.value[2] === 'DE') {
                    return time[0] + ':' + time[1] + ', No Readings';
                  }
                  if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                    return time[0] + ':' + time[1] + ',Calib Error';
                  }
                  return time[0] + ':' + time[1] + ', warm up';
                }
              },
            },
            symbolSize: 2,
          },
          {
            type: 'scatter',
            data: chart_calib,
            symbol: 'image://static/legend/calib.png',
            tooltip: {
              trigger: 'item',
              z: 999,
              backgroundColor: '#555',
              formatter: function (params) {
                let tip = auth.formatterTip1([params], that, 'ds');
                return tip;
              },
            },
          },
          {
            type: 'scatter',
            data: bg_calib,
            symbol: 'image://static/legend/calibrate_1.png',
            tooltip: {
              backgroundColor: '#555',
              formatter: function (params) {
                let date = params.value[0];
                let time = auth.formatterDate5(date);
                return time[0] + ':' + time[1] + ',BG ' + params.value[1];
              },
            },
          },
          {
            type: 'scatter',
            data: this.transmtr,
            symbol: 'rect',
            symbolSize: 5,
            itemStyle: { normal: { color: '#00a107' } },
            tooltip: {
              backgroundColor: '#333',
              formatter: function (params) {
                let date = params.value[0];
                let time = auth.formatterDate5(date);
                return time[0] + ':' + time[1] + ', ' + 'New Sensor';
              },
            },
          },
          {
            type: 'scatter',
            data: this.sensor_alarm,
            symbol: 'image://static/legend/Alert.png',
            symbolSize: 13,
            tooltip: {
              backgroundColor: '#333',
              formatter: function (params) {
                let date = params.value[0];
                let time = auth.formatterDate5(date);
                return time[0] + ':' + time[1] + ', ' + params.value[2];
              },
            },
          },
          {
            type: 'custom',
            data: chart_sleepTime,
            z: -1,
            renderItem: function (params, api) {
              let y = api.value(2);
              let start = api.coord([api.value(0), y]);
              let size = api.size([api.value(1) - api.value(0), y]);
              let style = api.style();
              return {
                type: 'rect',
                shape: {
                  x: start[0],
                  y: start[1],
                  width: size[0],
                  height: size[1],
                },
                style: style,
              }
            },
            tooltip: { show: false, },
            itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } },
          },
        ],
      });
    },

  },
}
</script>

<style scoped>
.container {
  padding-top: 0mm;
  width: 100%;
  background: #ccc;
}

.container .noprint {
  float: left;
  border-radius: 100px;
  background: #3396ff;
  border: 1px solid #a3a3a3;
  outline: none;
  margin-top: 4px;
  width: 90px;
  height: 26px;
  line-height: 28px;
  cursor: pointer;
  margin-left: 120px;
  font-size: 13px;
  text-align: center;
  position: fixed;
}

.container .noprint:nth-child(1) {
  margin-left: 0px;
}

.chart-container {
  width: 300mm;
  *height: 800mm;
  font-family: SFUIText-Regular;
  font-size: 12px;
  color: #282828;
  letter-spacing: -0.34px;
  background: #fff;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}

.page {
  width: 297mm;
  height: 202mm;
  padding-top: 5mm;
  border: 1px solid #fff;
}

p,
body,
html {
  margin: 0;
}

.page .title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.page .table-head table {
  width: 96%;
  margin: 0 auto;
  font-size: 0.15in;
}

.page .sep {
  width: 96%;
  margin: 0 auto;
  height: 2px;
  background-color: #333;
}

.page .content table {
  width: 96%;
  margin: 0 auto;
  margin-top: 1mm;
  font-size: 0.15in;
  border: 1px solid #747474;
  border-collapse: collapse;
}

.page .content table td {
  border: 1px solid #747474;
}

.page .content table .stat_res td {
  text-align: center;
  height: 24px;
}

.page .text-wrap {
  font-size: 0.15in;
  width: 96%;
  margin: 0 auto;
  margin-top: 1mm;
}

.page .chart-wrap {
  font-size: 0.15in;
  width: 96%;
  margin: 0 auto;
}

.page .chart-wrap>div {
  width: 49%;
  float: left;
  height: 40mm;
  font-size: 0.12in;
}

.page .chart-wrap>div:nth-child(2*n + 1) {
  margin-left: 1%;
}

.page .chart-wrap>div:nth-child(n + 3) {
  margin-top: 3mm;
}

.page .chart-wrap .chart {
  height: 38mm;
}

.page .chart-wrap .legend-wrap {
  margin-top: 5mm;
  margin-left: 5mm;
}

.page .chart-wrap .legend-wrap img {
  width: 96%;
}

.page .chart-wrap .legend-wrap>div {
  float: left;
  margin-bottom: 5mm;
}

.page .chart-wrap .legend-wrap>div:nth-child(n + 2) {
  margin-left: 5mm;
}

.page .chart-wrap .legend-wrap div span {
  margin-left: 1mm;
}

.agp-report .content {
  font-size: 0.15in;
  width: 96%;
  margin: 0 auto;
  margin-top: 3mm;
}

.agp-report .content .row1>div {
  float: left;
}

.agp-report .content .row1 .col1 {
  width: 70%;
}

.agp-report .content .row1 .col1 table td {
  text-align: center;
}

.agp-report .content .row1 .col2 {
  width: 8mm;
  margin-left: 20mm;
  margin-top: 5mm;
}

.agp-report .content .row1 .col2 .high {
  height: 10mm;
  /*background-color:#ffad00 !important;*/
  -webkit-print-color-adjust: exact;
}

.agp-report .content .row1 .col2 .target {
  height: 10mm;
  /*background-color:#21ca3b !important;*/
  -webkit-print-color-adjust: exact;
}

.agp-report .content .row1 .col2 .low {
  height: 10mm;
  /*background-color:#ff4e4e !important;*/
  -webkit-print-color-adjust: exact;
}

.agp-report .content .row1 .col3 {
  margin-left: 3mm;
  width: 52mm;
  margin-top: 5mm;
  font-size: 0.1in;
}

.agp-report .content .row1 .col3 div {
  height: 5mm;
  position: relative;
}

.agp-report .content .row1 .col3 div p {
  position: absolute;
}

.agp-report .content .row1 .col3 div.high p {
  top: -1mm;
}

.agp-report .content .row1 .col3 div.target p {
  /* top: 40%; */
}

.agp-report .content .row1 .col3 div.low p {
  bottom: 0;
  transform: translateY(50%);
}

.agp-report .content .row2 #agp-chart {
  height: 80mm;
}

.footer {
  width: 297mm;

}

.footer table {
  width: 96%;
  margin: 0 auto;
  font-size: 0.15in;
}

.footer table .right {
  text-align: center;
}

hr {
  width: 96%;
  margin: 0 auto;
}

.event-list {
  position: relative;
  top: -10mm;
  border: 1px solid #cccccc;
  width: 92%;
  margin-left: 5%;
  height: 5mm;
}

/* .event-list img {
  position: absolute;
} */

.event-list .event-item {
  position: absolute;
}

.event-item {
  display: inline-block;
  border: 1px solid #00ff4c;
  border-radius: 4px;
  height: 4mm;
  line-height: 18px;
  position: absolute;
  font-size: 13px;
  color: #000;
  letter-spacing: -0.34px;
  text-align: center;
  background-color: #00ff4c;
  top: 1px;
}

.event-title {
  display: inline-block;
}

.title p {
  /* display: inline-block; */
  display: flex;
  width: 100%;
  justify-content: center;
  height: 80%;
}

.img {
  width: 20px;
  height: 20px;
  position: absolute;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// HCGMReport.vue?3736e3f1